import { useCreativeAiAccess } from './composables/useCreativeAiAccess'

import type { SettingsNavEntry } from '@/features/workspace-settings'

export const creativeAiSettingsNavEntry: SettingsNavEntry = {
  key: 'creative-ai',
  labelKey: 'creativeAi.settings.nav.title',
  icon: 'gear',
  group: 'workspace',
  // Sixth inside the Workspace group, between Product Customization and Negative Keywords —
  // New Front's child order (`useWorkspaceSettings.js:143-186`).
  order: 55,
  routeName: 'SettingsCreativeAi',
  visible: () => useCreativeAiAccess().canView.value,
}
